"use client";
import { memo } from "react";
import CheckoutHeader from "@/components/screen/global-components/checkout/CheckoutHeader/CheckoutHeader";
import dynamic from "next/dynamic";
import Spinner from "@/components/ui/spinner";
import GetQuoteSupport from "./components/GetQuoteSupport";

const Checkout = dynamic(
  () => {
    return import("./components/Checkout");
  },
  {
    ssr: false,
    loading: () => {
      return (
        <div className="flex flex-auto items-center justify-center w-full">
          <Spinner />
        </div>
      );
    },
  }
);

export const QuoteOrderPage = () => {
  return (
    <>
      <CheckoutHeader />
      <main className="w-full full-height bg-white flex flex-col">
        <Checkout />
        <GetQuoteSupport />
      </main>
    </>
  );
};

export default memo(QuoteOrderPage);
